import {dash} from '../lib/urlTools';
import {amountFormatting} from '../lib/formatting';
import _find from 'lodash/find';
import _get from 'lodash/get';

export const getImage = (state, propertyType) => {
  let fallbackImage = '/assets/images/icon_happy.svg';
  if (state.suburbProperty
    && state.suburbProperty.detail
    && state.suburbProperty.detail[propertyType]
    && state.suburbProperty.detail[propertyType]['links']) {
    let mainImage = _find(state.suburbProperty.detail[propertyType]['links'], {'rel': 'mainImage'});
    if (mainImage && mainImage.href) {
      return mainImage.href;
    }
    else {
      return fallbackImage;
    }
  }
  return fallbackImage;
};

export const getPrice = (state, propertyType) => {
  if (state.suburbProperty
    && state.suburbProperty.detail
    && state.suburbProperty.detail[propertyType]) {
    let detail = state.suburbProperty.detail[propertyType];
    switch (propertyType) {
      case 'sale':
      case 'rent':
        if (detail.listing && detail.listing.displayPrice) {
          let price = detail.listing.displayPrice;
          if (propertyType == 'sale') {
            if (price.match(/sale/i)) {
              return price;
            }
            else {
              return 'For sale: ' + price;
            }
          }
          if (propertyType == 'rent') {
            if (price.match(/[per week|p\/w]/i)) {
              return 'For rent: ' + price;
            }
            else {
              return 'For rent: ' + price + ' per week';
            }
          }
        }
        else {
          return '';
        }
      case 'sold':
        if (detail.guesstimate && detail.guesstimate.price) {
          return 'Last Sold: ' + amountFormatting(detail.guesstimate.price);
        }
        return '';
    }
  }
  return '';
};

export const getAttributes = (state, propertyType) => {
  let beds = 0;
  let baths = 0;
  let carSpaces = 0;

  if (state.suburbProperty
  && state.suburbProperty.detail
  && state.suburbProperty.detail[propertyType]) {
    let detail = state.suburbProperty.detail[propertyType];
    if (detail.beds) {
      beds = detail.beds;
    }
    if (detail.baths) {
      baths = detail.baths;
    }
    if (detail.carSpaces) {
      carSpaces = detail.carSpaces;
    }
  }

  return [
    {type: 'beds', value: beds},
    {type: 'baths', value: baths},
    {type: 'carSpaces', value: carSpaces},
  ];
};

export const getSearchUrl = (state, propertyType) => {
  let searchUrl = null;
  let detail = _get(state, 'suburbProperty.detail.offmarket');
  if (detail && detail.length) {
    detail = detail[0];
    searchUrl = detail.address.stateCode.toLowerCase() + '/'
      + detail.address.suburb.replace(dash, '--').replace(/\s/igm, '-').toLowerCase() + '-'
      + detail.address.postCode;
    switch (propertyType) {
      case 'sale':
        searchUrl = '/property-for-sale/' + searchUrl;
        break;
      case 'rent':
        searchUrl = '/property-for-rent/' + searchUrl;
        break;
      case 'sold':
        searchUrl = '/sold/' + searchUrl;
        break;
      case 'offmarket':
        searchUrl = '/property/' + searchUrl;
        break;
    }
  }
  return searchUrl;
};

export const getSuburbMarketId = (address) => {
  return address ? address.suburb.toUpperCase().replace(/ /g, '+') + '+' +
      (address.postCode ? address.postCode : address.postcode) : '';
};

export const getStateBySuburbWithPostCode = (suburbWithPostcode) => {
  const postcode = suburbWithPostcode.replace(/^\D+/g, '');

  if((postcode >= 1000 && postcode <= 2599) ||
      (postcode >= 2619 && postcode <= 2899) ||
      (postcode >= 2921 && postcode <= 2999)) {
    return 'nsw';
  } else if ((postcode >= 2900 && postcode <= 2920) ||
      (postcode >= 200 && postcode <= 299) ||
      (postcode >= 2600 && postcode <= 2618)) {
    return 'act';
  } else if ((postcode >= 3000 && postcode <= 3999) ||
      (postcode >= 8000 && postcode <= 8999)) {
    return 'vic';
  } else if ((postcode >= 4000 && postcode <= 4999) ||
      (postcode >= 9000 && postcode <= 9999)) {
    return 'qld';
  } else if (postcode >= 5000 && postcode <= 5999) {
    return 'sa';
  } else if ((postcode >= 6000 && postcode <= 6797) ||
      (postcode >= 6800 && postcode <= 6999)) {
    return 'wa';
  } else if (postcode >= 7000 && postcode <= 7999) {
    return 'tas';
  } else if (postcode >= 800 && postcode <= 999) {
    return 'nt';
  }

  return '';
};
